import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import sicon1 from "../../icons/icon_google.svg";
import appleIcon from "../../icons/Apple_icon.png";
import coinIcon from "../../images/site_logo/TC-Logo-icon.png";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./style.css";
import { API_URL } from "../../constant";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Function to open URL in new tab with fallback for different browsers
  const openInNewTab = (url) => {
    // Method 1: Try window.open (works on desktop + Android)
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");

    // Method 2: Fallback for iOS Safari and strict browsers
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";

      // Temporarily add to DOM for iOS
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Function to clear form fields
  const clearFormFields = () => {
    setEmail("");
    setPassword("");
    setPasswordVisible(false);
  };

  // Function to clear message after delay
  const clearMessageAfterDelay = (delay = 10000) => {
    setTimeout(() => {
      setMessage({ text: "", type: "" });
    }, delay);
  };

  const handleGoogleLogin = () => {
    // Get referral code from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get("ref");

    const callbackUrl = `${window.location.origin}/auth/google/callback`;
    let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
      callbackUrl
    )}`;

    // Add referral code to Google OAuth URL if present - use multiple methods
    if (referralCode) {
      // Method 1: Standard query parameter
      googleAuthUrl += `&ref=${encodeURIComponent(referralCode)}`;

      // Method 2: Also store in localStorage as backup
      localStorage.setItem("pending_oauth_referral", referralCode);

      console.log("🔗 Opening Google OAuth with referral:", referralCode);
    }

    // Open Google OAuth in same tab instead of new tab for better session handling
    window.location.href = googleAuthUrl;
  };

  const handleAppleLogin = () => {
    window.open(`${API_URL}/api/auth/apple`, "_blank");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const response = await fetch(`${API_URL}/api/customer/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store the authentication token and user data
        localStorage.setItem("auth_token", data.access_token);
        localStorage.setItem("user", JSON.stringify(data.user));

        setMessage({
          text: "Login successful! Opening wallet in new tab...",
          type: "success",
        });

        // Clear form fields
        clearFormFields();

        // Open wallet in new tab and refresh current page
        setTimeout(() => {
          openWalletInNewTabAndRefresh();
        }, 1500);
      } else {
        setMessage({
          text: data.message || "Login failed. Please check your credentials.",
          type: "error",
        });
        clearMessageAfterDelay(10000);
      }
    } catch (error) {
      setMessage({
        text: "Network error. Please check your connection and try again.",
        type: "error",
      });
      clearMessageAfterDelay(10000);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to open wallet in new tab and refresh current page
  const openWalletInNewTabAndRefresh = () => {
    const walletUrl = `${window.location.origin}/customer/wallet`;

    // Method 1: Try to open in new tab
    const newWindow = window.open(walletUrl, "_blank");

    // Method 2: Fallback for popup blockers
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      // If popup blocked, show message with link
      setMessage({
        text: "Login successful! Popup was blocked. Please click the link below to open your wallet.",
        type: "success",
      });

      // Add manual link to message
      setTimeout(() => {
        const manualLink = document.createElement("a");
        manualLink.href = walletUrl;
        manualLink.target = "_blank";
        manualLink.style.display = "none";
        document.body.appendChild(manualLink);
        manualLink.click();
        document.body.removeChild(manualLink);
      }, 500);
    }

    // Refresh the current login page to clear form (with slight delay)
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  // Also update your message display to include the manual link
  {
    message.text && (
      <div
        style={{
          ...messageStyle,
          backgroundColor: message.type === "error" ? "#ffebee" : "#e8f5e9",
          color: message.type === "error" ? "#c62828" : "#2e7d32",
          border:
            message.type === "error"
              ? "1px solid #ffcdd2"
              : "1px solid #c8e6c9",
        }}
      >
        {message.text}
        {message.type === "success" && (
          <div style={{ marginTop: "10px" }}>
            <a
              href="/customer/wallet"
              target="_blank"
              style={{
                color: "#2D4CA8",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
              onClick={(e) => {
                e.preventDefault();
                window.open("/customer/wallet", "_blank");
                window.location.reload();
              }}
            >
              Open Wallet in New Tab
            </a>
          </div>
        )}
        <button
          onClick={() => setMessage({ text: "", type: "" })}
          style={{
            background: "none",
            border: "none",
            color: "inherit",
            marginLeft: "10px",
            cursor: "pointer",
            float: "right",
            fontSize: "16px",
          }}
          title="Dismiss message"
        >
          ×
        </button>
      </div>
    );
  }

  // Safari-compatible redirect function
  const redirectToWallet = () => {
    const walletUrl = "/customer/wallet";

    // Method 1: Try standard navigation first
    try {
      navigate(walletUrl);
      return;
    } catch (error) {
      console.log("Navigate failed, trying fallback");
    }

    // Method 2: Use window.location (bypasses React Router but works in Safari)
    try {
      window.location.href = walletUrl;
      return;
    } catch (error) {
      console.log("Window location failed, trying fallback");
    }

    // Method 3: Create a temporary link click (most reliable for Safari)
    try {
      const link = document.createElement("a");
      link.href = walletUrl;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    } catch (error) {
      console.log("Link click failed, trying final fallback");
    }

    // Method 4: Final fallback - show manual link
    setMessage({
      text: "Login successful! If not redirected, please click here to go to your wallet.",
      type: "success",
    });
  };

  // Also update the message display to include a manual redirect link
  {
    message.text && (
      <div
        style={{
          ...messageStyle,
          backgroundColor: message.type === "error" ? "#ffebee" : "#e8f5e9",
          color: message.type === "error" ? "#c62828" : "#2e7d32",
          border:
            message.type === "error"
              ? "1px solid #ffcdd2"
              : "1px solid #c8e6c9",
        }}
      >
        {message.text}
        {message.type === "success" && message.text.includes("successful") && (
          <div style={{ marginTop: "10px" }}>
            <a
              href="/customer/wallet"
              style={{
                color: "#2D4CA8",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Go to Wallet Now
            </a>
          </div>
        )}
        <button
          onClick={() => setMessage({ text: "", type: "" })}
          style={{
            background: "none",
            border: "none",
            color: "inherit",
            marginLeft: "10px",
            cursor: "pointer",
            float: "right",
            fontSize: "16px",
          }}
          title="Dismiss message"
        >
          ×
        </button>
      </div>
    );
  }

  useEffect(() => {
    if (location.hash === "#google-login-button") {
      const el = document.getElementById("google-login-button");
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const name = params.get("name");
    const email = params.get("email");
    const firstLogin = params.get("firstLogin") === "true";

    if (token) {
      localStorage.setItem("auth_token", token);
      localStorage.setItem("user_name", name || "");
      localStorage.setItem("user_email", email || "");
      localStorage.setItem("is_first_login", firstLogin ? "true" : "false");
    }

    // Check if user is already logged in
    const authToken = localStorage.getItem("auth_token");
    if (authToken) {
      // Use openInNewTab instead of navigate
    }
  }, []);

  // Message style
  const messageStyle = {
    textAlign: "center",
    padding: "10px",
    borderRadius: "8px",
    margin: "10px 0",
    fontWeight: "500",
  };

  return (
    <Fragment>
      <div
        className="index_ico page_wrapper "
        style={{
          backgroundColor: "#001964",
          color: "#fff",
        }}
      >
        <Header />
        <main className="page_content">
          <section className="register_section section_decoration py-5">
            <div className="container">
              <div className="row align-items-center">
                {/* LEFT SIDE CONTENT */}
                <div className="col-lg-7 mb-5 mb-lg-0 ">
                  <h1 className="fw-bold mt-5 mb-3">
                    Welcome to TopCoin UK - Where Loyalty Turns into Real
                    Rewards!
                  </h1>
                  <p>
                    Once someone joins TopCoin UK, they're given their own
                    Personal ID and Agent ID – instantly unlocking access to our
                    powerful earning system.
                  </p>
                  <h4 className="fw-bold mt-4">
                    How Agents Earn Free TopCoin:
                  </h4>
                  <p>
                    As a TopCoin UK Agent, you earn free TopCoin effortlessly
                    every time you refer someone!
                  </p>
                  <ul>
                    <li>When someone you introduce makes a purchase,</li>
                    {/* <li>And they enter your Agent ID,</li> */}
                    <li>
                      You'll instantly receive the same number of TopCoin they
                      earn – automatically!
                    </li>
                  </ul>
                  <p>
                    The more people you refer, the more your TopCoin balance
                    grows – and with it, your TopCoin wallet power. Start
                    sharing. Start earning.
                  </p>
                  <p>
                    Be the reason others discover TopCoin – and get rewarded
                    every step of the way.
                  </p>
                  <p>
                    <strong>Your loyalty is your power. Make it count.</strong>
                  </p>
                </div>

                {/* RIGHT SIDE LOGIN BOX */}
                <div className="col-lg-5" id="google-login-button">
                  <div
                    className="bg-white text-center shadow p-4 margin-top-lg"
                    style={{
                      color: "#000",
                      borderRadius: "20px",
                    }}
                  >
                    <div className="d-flex justify-content-center mb-3">
                      <img
                        src={coinIcon}
                        alt="TopCoin UK"
                        style={{ width: 150, height: 150 }}
                      />
                    </div>

                    <h4
                      className="fw-bold mb-2"
                      style={{
                        background:
                          "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        display: "inline-block",
                      }}
                    >
                      Welcome Back to
                      <br /> TopCoin UK
                    </h4>
                    <h3 className="sub-title">Enter your Email and Password</h3>

                    {/* Message display */}
                    {message.text && (
                      <div
                        style={{
                          ...messageStyle,
                          backgroundColor:
                            message.type === "error" ? "#ffebee" : "#e8f5e9",
                          color:
                            message.type === "error" ? "#c62828" : "#2e7d32",
                          border:
                            message.type === "error"
                              ? "1px solid #ffcdd2"
                              : "1px solid #c8e6c9",
                        }}
                      >
                        {message.text}
                        <button
                          onClick={() => setMessage({ text: "", type: "" })}
                          style={{
                            background: "none",
                            border: "none",
                            color: "inherit",
                            marginLeft: "10px",
                            cursor: "pointer",
                            float: "right",
                            fontSize: "16px",
                          }}
                          title="Dismiss message"
                        >
                          ×
                        </button>
                      </div>
                    )}

                    {/* Login Form */}
                    <form onSubmit={handleLogin} className="text-start mb-4">
                      <div className="mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#052C65" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control bg-white"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={isLoading}
                          style={{
                            borderRadius: "8px",
                            padding: "12px",
                            border: "1px solid #ccc",
                            color: "black",
                          }}
                        />
                      </div>

                      <div className="mb-2 position-relative">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#052C65" }}
                        >
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            className="form-control bg-white"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            style={{
                              borderRadius: "8px",
                              padding: "12px",
                              border: "1px solid #ccc",
                              color: "black",
                              paddingRight: "40px", // Add padding to prevent text overlap
                            }}
                          />
                          <span
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "12px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#666",
                              zIndex: 2,
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {passwordVisible ? (
                              <FaEye size={18} />
                            ) : (
                              <FaEyeSlash size={18} />
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Forgot Password Link */}
                      <div className="mb-4 text-end">
                        <a
                          href="/forgot-password"
                          style={{
                            color: "#2D4CA8",
                            fontWeight: "500",
                            textDecoration: "none",
                          }}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      <button
                        type="submit"
                        className="w-100 text-white fw-bold py-2"
                        disabled={isLoading}
                        style={{
                          backgroundColor: isLoading ? "#666" : "#0000A0",
                          borderRadius: "8px",
                          border: "none",
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                        }}
                      >
                        {isLoading ? "Logging in..." : "Login"}
                      </button>
                    </form>

                    <div className="d-flex align-items-center justify-content-center mb-3 mt-3">
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                      <span className="px-2" style={{ color: "#666" }}>
                        or
                      </span>
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                    </div>

                    <div
                      className="d-flex justify-content-center"
                      style={{ gap: "12px" }}
                    >
                      {/* Google Login Button */}
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (isLoading) return;

                          // Build the same Google OAuth URL as handleGoogleLogin but open in a new tab
                          const urlParams = new URLSearchParams(window.location.search);
                          const referralCode = urlParams.get("ref");
                          const callbackUrl = `${window.location.origin}/auth/google/callback`;
                          let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
                            callbackUrl
                          )}`;

                          if (referralCode) {
                            googleAuthUrl += `&ref=${encodeURIComponent(referralCode)}`;
                            localStorage.setItem("pending_oauth_referral", referralCode);
                            console.log("🔗 Opening Google OAuth with referral (new tab):", referralCode);
                          }

                          // Use component helper to open in a new tab with fallbacks
                          openInNewTab(googleAuthUrl);
                        }}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px 5px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      >
                        <img src={sicon1} alt="Google" width="33" height="35" />
                      </button>

                      {/* Apple Login Button */}
                      {/* <button
                        onClick={handleAppleLogin}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      >
                        <img
                          src={appleIcon}
                          alt="Apple"
                          width="40"
                          height="40"
                        />
                      </button> */}
                    </div>

                    <div className="mt-4">
                      <p className="mb-0" style={{ color: "#666" }}>
                        Don't have an account yet?{" "}
                        <a
                          href={`/create-account${window.location.search}`}
                          target="_blank"
                          style={{
                            color: "#2D4AFF",
                            textDecoration: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Create Account
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </Fragment>
  );
}

export default LoginPage;
